import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CloudinaryContext, Image } from 'cloudinary-react';
import ScreenSaverComponent from "../../components/screenSaver/ScreenSaver";

const configurationManager = require('../../utils/config/configurationManager');
var stateManager = require('../../utils/state/stateManager.js');
var screenSaverAction = require('../../utils/state/actions/views/screenSaver/screenSaverAction');
class ScreenSaver extends Component 
{
    render()
    {
        if (!this.props.screenSaver)
            return null;

        return <div className='h-100 w-100' style={{position:'fixed', 
                            top:'0px', left:'0px', 
                            background:'black', zIndex:'99999'}}
                    onClick={(event) =>
                    {
                        event.stopPropagation();
                        stateManager.getStore().dispatch(screenSaverAction.createAction(false));
                    }}>
                    {this.renderScreenSaverContents()}
                    {this.renderSignatureComponent()}
                </div>
    }

    renderScreenSaverContents()
    {
        return <div className='h-100 primary-color d-flex flex-column justify-content-center align-items-center'>
                    <ScreenSaverComponent/>
                </div>
    }

    renderSignatureComponent()
    {
        var cloudName = configurationManager.getConfig().cdnAppCloudName;
        var imageUrl = "app/signage/poweredby_white.png";

        return <div style={{position:'fixed', bottom:'0px', width:'100%', textAlign:'center', paddingRight:'20px', paddingBottom:'10px'}}>
                    <table style={{width:'100%'}}>
                            <tr>
                                <td style={{textAlign:'end'}}>
                                    <CloudinaryContext cloudName={cloudName} dpr="auto">
                                        <div className='make-child-img-black-color'>
                                            <Image publicId={imageUrl} responsive width={Math.trunc(window.innerWidth * 0.10)} crop="scale" />
                                        </div>
                                    </CloudinaryContext>
                                </td>
                            </tr>
                        </table>
                    
                </div>
    }
}

const mapStateToProps = state => 
{
    return { 
              screenSaver: state.screenSaver,  
          }
}

export default connect(mapStateToProps)(ScreenSaver)